import { Button } from "@letsbit/milkylb";
import { useGetOperatorContact } from "hooks/merk/useGetOperatorContact";
import { FormattedMessage } from "react-intl";
import { messages } from "./messages";

export const ContactOperatorButton: React.FC = () => {
  const { data } = useGetOperatorContact();

  return (
    data && (
      <a href={data?.whatsapp} target="_blank">
        <Button className="w-full">
          <FormattedMessage {...messages.text} />
        </Button>
      </a>
    )
  );
};
